export default "__VITE_ASSET__DsPWJM18__"